import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NamedLink, H4 } from '../index';
import { FormattedMessage } from '../../util/reactIntl';

import css from './ListingPageTab.module.css';

const ListingPageTab = props => {
    const { className, rootClassName, listingTitle } = props;

    const classes = classNames(rootClassName || css.root, className);

    return (
        <nav className={classes}>
            <NamedLink name="LandingPage" className={css.link}>
                <FormattedMessage id="ListingPageTab.home" />
            </NamedLink>
            <span className={css.separator}>&gt;</span>
            <NamedLink name="SearchPage" className={css.link}>
                <FormattedMessage id="ListingPageTab.annonser" />
            </NamedLink>
            {listingTitle && (
                <>
                    <span className={css.separator}>&gt;</span>
                    <H4 as="h1" className={css.current}>{listingTitle}</H4>
                </>
            )}
        </nav>
    );
};

ListingPageTab.defaultProps = {
    className: null,
    rootClassName: null,
    listingTitle: null,
};

ListingPageTab.propTypes = {
    className: PropTypes.string,
    rootClassName: PropTypes.string,
    listingTitle: PropTypes.string,
};

export default ListingPageTab;
